module.exports = __webpack_public_path__ + "img/mehmet-kirci-start4.018e96f5.png";